import type { CliveMood } from '~/components/Clive/cliveRegistry';

// Specific type for recommendation panels (only happy, loading and error)
export type CliveRecommendationAvatarType = Extract<CliveMood, 'happy' | 'loading' | 'error'>;

export interface Recommendation {
  title: string;
  explanation_component: React.ReactNode;
  classification_reasons: ClassificationReason[];
  actionComponent: React.ReactNode;
}

interface SourceQuote {
  location_desc: string;
  quote: string;
}

export interface ClassificationReason {
  reason: string;
  quotes: SourceQuote[] | null;
}

export enum CliveContentType {
  SUMMARY = 'summary',
  TRANSCRIPT = 'transcript',
}
